import {hitType} from "../../analytics.helper";
import {sourceActionTypes} from "../../../../_constants";
import {__isKeyAvailable} from "../../../commons/utility.helper";
import {orderHelper} from "../../../order.helper";

// UTILITY-HELPERS ##########################################################

// generic order event
const genericOrderEvent = (event, values = {}) => {
	return {
		event: event,
		hitType: hitType.EVENT,
		values: values,
	};
};

// cost-calc-helper
const getCost = (props) => {
	let cost = -1;	// fallback - negative amount if cannot be retrieved
	if(__isKeyAvailable(props, "order", "source", "usage", "summary")) {
		orderHelper.getOrderCost(props.order.source.usage.summary);
	}
	return cost;
}

// EVENTS ##########################################################

// order gist - click event
const orderGist = (action, prevProps) => genericOrderEvent(sourceActionTypes.ORDER_SOURCE_REQUEST, getCost(prevProps));

// cancel order gist - click event
const cancelOrderGist = (action, prevProps) => genericOrderEvent(sourceActionTypes.ORDER_SOURCE_RESET, getCost(prevProps));

// EVENT-MAPPINGS ##########################################################

// order events mappings
export const orderEventsMap = {
	[sourceActionTypes.ORDER_SOURCE_REQUEST]    :   orderGist,
	[sourceActionTypes.ORDER_SOURCE_RESET]      :   cancelOrderGist,
};